import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

/** Lo que el núcleo da de cada comercio para pintar su avatar (ESC-03). */
export interface Estampa { code: string; nombre: string; iniciales: string; color: string; letra: string; logo: boolean; logo_v: string | null; logoUrl?: string | null; }

/**
 * ESTAMPA DEL COMERCIO (Mario, 12-oct; ESC-05): las estampas de todos los comercios, pedidas UNA vez por sesión. El
 * logo es una imagen pública aparte, con su versión en la URL para que el navegador la guarde.
 */
@Injectable({ providedIn: 'root' })
export class EstampasService {
  private base = `${environment.BASE_LA}`;
  private pedido: Promise<Map<string, Estampa>> | null = null;

  constructor(private http: HttpClient) { }

  todas = (): Promise<Map<string, Estampa>> => {
    if (!this.pedido) {
      this.pedido = lastValueFrom(this.http.get<{ estampas: Estampa[] }>(`${this.base}/api/merchant/estampas`))
        .then((r) => new Map<string, Estampa>(((r && r.estampas) || []).map((e): [string, Estampa] => [e.code,
          { ...e, logoUrl: e.logo ? `${this.base}/api/merchant/${encodeURIComponent(e.code)}/logo?v=${e.logo_v}` : null }])))
        .catch(() => { this.pedido = null; return new Map<string, Estampa>(); });
    }
    return this.pedido as Promise<Map<string, Estampa>>;
  };

  /** La estampa de un comercio; sin comercio, la de Mundo Total. Desconocido: sus dos primeras letras en gris. */
  de = async (code: string | null | undefined): Promise<Estampa> => {
    const c = String(code || 'MT').toUpperCase();
    const m = await this.todas();
    return m.get(c) || { code: c, nombre: c, iniciales: c.slice(0, 2), color: '#E5E7EB', letra: '#374151', logo: false, logo_v: null, logoUrl: null };
  };

  /** Al cerrar sesión, se vuelve a pedir con la próxima. */
  olvidar = (): void => { this.pedido = null; };
}
